import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

import { businessTypesEndpoints as businessTypes } from './businessTypes'
import { fieldsEndpoints as fields } from './fields'

const baseUrl = '/data-source-templates'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  getSingle: SingleParamEndpointConstructor
  create: NoParamEndpointConstructor
  update: SingleParamEndpointConstructor
  remove: SingleParamEndpointConstructor
  updateTemplateFields: SingleParamEndpointConstructor
  destroyPreview: SingleParamEndpointConstructor
  projectHierarchies: SingleParamEndpointConstructor
  businessTypes: typeof businessTypes
  fields: typeof fields
}

export const templatesEndpoints: Endpoints = {
  getAll: () => `${baseUrl}`,
  getSingle: (id) => `${baseUrl}/${id}`,
  create: () => `${baseUrl}`,
  update: (id) => `${baseUrl}/${id}`,
  remove: (id) => `${baseUrl}/${id}`,
  updateTemplateFields: (templateId) => `${baseUrl}/${templateId}/fields`,
  destroyPreview: (id) => `${baseUrl}/${id}/destroy-preview`,
  projectHierarchies: (projectId) => `/projects/${projectId}/hierarchies`,
  businessTypes,
  fields,
}
